module.exports = __webpack_public_path__ + "assets/img/6d5e4b8768efa5c45838e875b5b9934e.svg";